import { render, staticRenderFns } from "./ScreenLaudoObstetrica.vue?vue&type=template&id=2847e104&lang=true&"
import script from "./ScreenLaudoObstetrica.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoObstetrica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports